const regulationPdfData = {
  // servicesEquipments:[{
  //     src:"/pdfs/Services and Capabalities.docx",
  //     name:"Services and Capabalities",
  //     data:"<h2>Services and Capabilities</h2><h3>Berths, Wharfs, and Multipurpose Built Terminals</h3><br/><p>The Saudi Ports Authority (Mawani) is the government authority responsible for the efficient, professional running of Saudi Arabia's ports. With a combined total of 290 berths, the Kingdom's ports comprise the Middle East's largest seaport network that not only contributes a great deal to national growth, but also showcases the Kingdom's formidable regional and international standing.</p><br/><p>Each terminal contains one or more berths, and can readily accommodate any form of vessel, which is what drove Mawani to provide specialized terminals for various types of loads, including containers, general cargos, refrigerated and frozen cargos, bulk cargo, roll-on/roll-off cargos, and livestock.</p><br/><p>Most of the Kingdom's ports have their own special zones, such as bonded storage and re-export, vessel repair facilities, indoor and outdoor storage, equipment depots, and service and maintenance centers.</p><br/><h3>Security, Safety, and the Environment</h3><br/><p>Saudi ports are safe havens to work and invest in. Mawani has redoubled its efforts to keep people, properties, the environment and operations at national ports safe. This is thanks to the implementation of state-of-the-art safety measures and information, navigation, antipollution, fire, and security systems adhered to by all operators. Mawani also complies to all International Ship and Port Facility Security Code (ISPS) rules and regulations, including the installation of security and CCTV systems, luggage scanners, and fire safety systems. Perimeter walls, controlled-access gates, and hydraulically operated blockers are standard, as are dedicated telecommunications, hydrographic surveys of seaport waters, and vessel tracking systems. Security patrol, safety, and ambulance vehicles are also supplied to all ports.</p><br/><p>Mawani also ensures a safe working and investment environment with the help of the Industrial Security Department of the Ministry of Interior, which handles the three primary domains of workplace wellbeing: security, safety, and firefighting. Mawani constantly evaluates the security status of each facility it oversees. It has also developed security and emergency plans accordingly with ideally designed and applied response and control plans, along with training for Industrial Security personnel.</p><br/><p>Mawani works to upgrade the performance of its emergency response teams with specialized training for any potential seaport accidents.</p><br/><p>As well as ensuring the competence of response teams through both training and simulation exercises.</p><br/><p>The Authority also applies global best practices to limit the environmental impact of each port and any vessels on the surrounding marine habitat.</p><br/><h3>Passenger Terminals</h3><br/><p>It has been said that there are no second chances for first impressions, and nothing communicates people's culture as strongly to visitors as do their passenger terminals. Mawani has spared no effort to ensure that passenger terminals are as welcoming to travelers to the Kingdom &ndash; especially pilgrims &ndash; as they can be. The warmth with which they are received reflects the extent of the Kingdom's care for each pilgrim's wellbeing, with every possible luxury and comfort being made available to them.</p><br/><p>As part of its efforts to support the National Transport and Logistics Strategy (NTLS), Mawani has boosted its involvement in empowering the maritime tourism sector with new and better-developed passenger terminals and dedicated berths for cruise ships.</p><br/>",
  //     releaseDate:"03/03/2022",
  //     type:"docx"
  // }
  // ],
  privatizationProgram: [
    // {
    //   src: '/pdfs/Privatization program.docx',
    //   name: 'Privatization program',
    //   nameAR: 'برنامج الخصخصة',
    //   releaseDate: '03/03/2022',
    //   type: 'docx',
    // },
  ],
  generalRegulationOfLicensing: [
    {
      src: '',
      srcAR: '/pdfs/regulations/ar/اللائحة العامة للتراخيص والتصاريح.pdf',
      name: '',
      nameAR: 'اللائحة العامة للتراخيص والتصاريح',
      releaseDate: '03/03/2022',
      type: 'PDF',
    },
  ],
  generalRegulationForControl: [
    {
      src: '/pdfs/regulations/General Regulation for control and inspection.pdf',
      srcAR: '/pdfs/regulations/ar/اللائحة العامة للرقابة والتفتيش.pdf',
      name: 'General Regulation for Control and Inspection',
      nameAR: 'اللائحة العامة للرقابة والتفتيش',
      releaseDate: '03/03/2022',
      type: 'PDF',
    },
  ],
  rulesForSeaPorts: [
    // {
    //   src: '/pdfs/Rules and regulations for seaports.pdf',
    //   srcAR: '/pdfs/اللائحة التشغيلية.pdf',
    //   name: 'Rules and regulations for seaports',
    //   nameAR: 'اللائحة التشغيلية للهيئة العامة للموانئ',
    //   releaseDate: '03/03/2022',
    //   type: 'PDF',
    // },
  ],
  regulationForShipChandler: [
    {
      src: '/pdfs/regulations/Regulation for ship chandlers.pdf',
      srcAR:
        '/pdfs/regulations/ar/اللائحة التنظيمية لمموني السفن ماعدا الوقود بجميع أشكاله .pdf',
      name: 'Regulation for Ship Chandlers (except for all types of fuel)',
      nameAR: 'اللائحة التنظيمية لمموني السفن ماعدا الوقود بجميع أشكاله',
      releaseDate: '03/03/2022',
      type: 'PDF',
    },
  ],
  regulationsForRentalOfFacilities: [
    {
      src: '',
      srcAR:
        '/pdfs/regulations/ar/لائحة تأجير أملاك الهيئة العامة الموانئ .pdf',
      name: '',
      nameAR: 'لائحة تأجير أملاك الهيئة العامة الموانئ ',
      releaseDate: '03/03/2022',
      type: 'PDF',
    },
  ],
  investorsGuide: [
     {
      src: "/pdfs/regulations/Investors_Guide_to_Licenses.pdf",
      srcAR:"/pdfs/regulations/ar/Investors_Guide_to_Licenses.pdf",
      name: "Investor's Guide to Licenses ",
      nameAR: "دليل المستثمر للتراخيص",
      releaseDate: '06/06/2023',
      type: 'PDF',
    },
  ],
  portServicesFeesandCharges: [
    {
      src: '/pdfs/regulations/Port Services Fees and Charges 3rd edition.pdf',
      srcAR: '/pdfs/regulations/ar/نظام رسوم وأجور خدمات الموانئ.pdf',
      name: 'Port Services Fees and Charges',
      nameAR: 'نظام رسوم وأجور خدمات الموانئ',
      releaseDate: '03/03/2022',
      type: 'PDF',
    },
  ],
  controlAndInseptionOfSaudiShips: [
    {
      src: '/pdfs/regulations/Control and inseption of Saudi ships.pdf',
      srcAR:
        '/pdfs/regulations/ar/التعليمات التنظيمية لإجراء الرقابة والتفتيش على السفن السعودية.pdf',
      name: 'Control and Inspection of Saudi Ships',
      nameAR: 'التعليمات التنظيمية لإجراء الرقابة والتفتيش على السفن السعودية',
      releaseDate: '03/03/2022',
      type: 'PDF',
    },
  ],
  controlAndInseptionOfForeignShips: [
    {
      src: '/pdfs/regulations/Control and inseption of foreign ships.pdf',
      srcAR:
        '/pdfs/regulations/ar/التعليمات التنظيمية لإجراءات الرقابة والتفتيش على السفن الأجنبية .pdf',
      name: 'Control and Inspection of Foreign Ships',
      nameAR:
        'التعليمات التنظيمية لإجراءات الرقابة والتفتيش على السفن الأجنبية',
      releaseDate: '03/03/2022',
      type: 'PDF',
    },
  ],
  saudiShips: [
    // {
    //   src: '/pdfs/saudi ships.pdf',
    //   srcAR: '',
    //   name: 'Saudi ships',
    //   nameAR: 'التعليمات التنظيمية على السفن السعودية',
    //   releaseDate: '03/03/2022',
    //   type: 'PDF',
    // },
  ],
  foreignShips: [
    // {
    //   src: '/pdfs/foreign ships.pdf',
    //   srcAR: '',
    //   name: 'Foreign ships',
    //   nameAR: 'التعليمات التنظيمية على السفن الاجنبية',
    //   releaseDate: '03/03/2022',
    //   type: 'PDF',
    // },
  ],
  regulationsForShippingAgents: [
    {
      src: '',
      srcAR: '/pdfs/regulations/ar/لائحة مزاولة نشاط الوكلاء الملاحيين 2.pdf',
      name: 'Regulations for Maritime Agents',
      nameAR: 'لائحة مزاولة نشاط الوكلاء الملاحيين',
      releaseDate: '03/03/2022',
      type: 'PDF',
    },
  ],
  regulationsForRentalOfFacilitiesOfTheSaudiPortsAuthority: [
    // {
    //   src: '/pdfs/RegulationsforleasingtheAuthoritypossessions.pdf',
    //   name: 'Regulations for leasing the Authority possessions',
    //   nameAR:
    //     'Regulations for leasing the Authority possessions - please supply AR',
    //   releaseDate: '03/03/2022',
    //   type: 'PDF',
    // },
  ],
  customsFeesMechanism: [
    // {
    //   srcAR: '/pdfs/آلية اجور الكشف الجمركي.pdf',
    //   name: '',
    //   nameAR: 'آلية اجور الكشف الجمركي',
    //   releaseDate: '03/03/2022',
    //   type: 'PDF',
    // },
  ],
  generalRegulationForSecuritySafetyHealthAndEnvironment: [
    {
      src: '',
      srcAR:
        '/pdfs/regulations/ar/اللائحة العامة للأمن والسلامة والصحة والبيئة.pdf',
      name: '',
      nameAR: 'اللائحة العامة للأمن والسلامة والصحة والبيئة',
      releaseDate: '03/03/2022',
      type: 'PDF',
    },
  ],
  generalRegulationForSecuritySafetyEnvironmentStandards: [
    {
      src: '/pdfs/regulations/Security Safety Environment Standards.pdf',
      srcAR: '',
      name: 'Security Safety Environment Standards',
      nameAR: '',
      releaseDate: '05/07/2023',
      type: 'PDF',
    },
  ],
  generalRegulationForOperationalregulationsoftheGeneralAuthorityforPorts: [
    {
      src: '',
      srcAR: '/pdfs/regulations/ar/اللائحة التشغيلية للهيئة العامة للموانئ.pdf',
      name: '',
      nameAR: 'اللائحة التشغيلية للهيئة العامة للموانئ',
      releaseDate: '05/07/2023',
      type: 'PDF',
    },
  ],
  generalRegulationForExecutiveProceduresManualforSecuritySafetyHealthandEnvironmentStandards:
    [
      {
        src: '',
        srcAR:
          '/pdfs/regulations/ar/دليل الاجراءات التنفيذية لمعايير الأمن والسلامة والصحة والبيئة.pdf',
        name: '',
        nameAR:
          'دليل الاجراءات التنفيذية لمعايير الأمن والسلامة والصحة والبيئة',
        releaseDate: '05/07/2023',
        type: 'PDF',
      },
    ],
  rulesandRegulationsforSeaportsforThecooperationCouncilforTheArabstatesofThegulf:
    [
      {
        src: '/pdfs/regulations/Rules and Regulations for Seaports forThecooperatlon Council for The Arab states of The gulf.pdf',
        srcAR:
          '/pdfs/regulations/ar/قواعد وتعليمات الموانئ البحريه لدول مجلس التعاون لدول الخليج العربي.pdf',
        name: 'Rules and Regulations for Seaports for The Cooperatlon Council for The Arab states of The Gulf',
        nameAR:
          'قواعد وتعليمات الموانئ البحريه لدول مجلس التعاون لدول الخليج العربي',
        releaseDate: '05/09/2023',
        type: 'PDF',
      },
    ],
};

export default regulationPdfData;
